
export const GET_PRODUCT_SUCCESS = "getProductsSuccess";
export const GET_PRODUCT_FAIL = "getProductsFail";




export const GET_PRODUCT_DETAILS_REQUEST = 'getProductDetailsRequest';
export const GET_PRODUCT_DETAILS_SUCCESS = 'getProductDetailsSuccess';
export const GET_PRODUCT_DETAILS_FAIL = 'getProductDetailsFail';
export const GET_PRODUCT_DETAILS_RESET = 'getProductDetailsReset';